<div class="min-h-screen bg-body transition-colors">
  <router-outlet></router-outlet>
  <app-loader *ngIf="isShowLoader"></app-loader>
</div>
